'use client'

import { ContentfulAviosOnlyPromotionContent } from '@reward-platform/contentful'
import React from 'react'
import styles from './FlightAviosOnlyBanner.module.scss'

type BannerProps = {
  aviosOnlyPromotionContent: ContentfulAviosOnlyPromotionContent
}

export function BannerContent({ aviosOnlyPromotionContent }: BannerProps) {
  const { introduction, descriptionPart1, aviosAmount, descriptionPart2, descriptionPart3 } =
    aviosOnlyPromotionContent

  return (
    <div className={styles.promoBannerContainer}>
      <div className={styles.promoBanner}>
        <div className={styles.content}>
          <div className={styles.contentWrapper}>
            <div className={styles.promoTextWrapper}>
              <p className={styles.promoTitle}>
                <span className={styles.introText}>{introduction}</span>
              </p>
              <div className={styles.promoDescription}>
                <span className={styles.promoText}>{descriptionPart1}</span>{' '}
                <span className={styles.aviosAmount}>{aviosAmount}</span>{' '}
                <span className={styles.promoText}>{descriptionPart2}</span>
              </div>
              <div className={styles.promoDescription}>
                <span className={styles.promoText}>{descriptionPart3}</span>
              </div>
              <p className={styles.disclaimerText}>T&Cs apply.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
